import { Card } from '@acin/ui-core';
import styled from 'styled-components';

export const Footer = styled(Card)`
  position: fixed;
  bottom: 0;
  right: 0;
  height: 60px;
  width: calc(50% - ${(p) => p.theme.spacing.getSize(2)});
  max-width: calc(100vw - ${(p) => p.theme.spacing.getSize(8)});
  box-sizing: border-box;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${(p) => p.theme.spacing.getSize(3)};
`;
